import { useEffect, useState } from 'react'

import { ShortcutText } from '@/components/shared-components/ShortcutText'

enum Mode {
  MAC,
  WINDOWS,
}

export const CommandKText: React.FC = () => {
  const [mode, setMode] = useState<Mode>(null)

  useEffect(() => {
    const idealPlatform = navigator?.['userAgentData']?.platform?.toUpperCase()
    const backupPlatform = navigator?.platform?.toUpperCase()

    const platform = idealPlatform || backupPlatform

    const isMac = platform?.indexOf('MAC') >= 0

    setMode(isMac ? Mode.MAC : Mode.WINDOWS)
  }, [])

  if (mode === null) return null
  if (mode === Mode.MAC) {
    return <ShortcutText keys={['⌘', 'K']} />
  }

  return <ShortcutText keys={['Ctrl', 'K']} />
}
